(function ($) {
    var win = $(window);

    win.on('load', function () {
        updateStayConnHeight();
        calcSocialTabPos();
        updateNav();
    }).on('resize', function () {
        updateStayConnHeight();
        calcSocialTabPos();
        updateNav();
        resetNav();
    });

    function updateStayConnHeight() {
        var stayConn = $('.stayConnected__container'),
            targetHeight = $('.feed-row-landing .dateList-news');

        if (stayConn.length > 0) {
            if (win.width() >= 1200) {
                stayConn.outerHeight(targetHeight.height());
            } else {
                stayConn.css('height', '');
            }
        }
    }

    function calcSocialTabPos() {
        setTimeout(function () {
            var parent = $('.SocialMediaFeed'),
                tabs = parent.find('.SMLink'),
                totalTabsWidth = 0,
                gap = $(window).width() >= 1200 ? 48 : 16,
                totalGaps = gap * 3;

            if ($(window).width() >= 768) {
                tabs.each(function () {
                    var me = $(this);

                    totalTabsWidth += me.width();
                })

                var sideSpacing = (parent.width() - totalTabsWidth - totalGaps) / 2,
                    left1 = sideSpacing,
                    left2 = left1 + tabs.eq(0).width() + gap,
                    left3 = left2 + tabs.eq(1).width() + gap,
                    left4 = left3 + tabs.eq(2).width() + gap;

                tabs.eq(0).css('left', left1 + 'px');
                tabs.eq(1).css('left', left2 + 'px');
                tabs.eq(2).css('left', left3 + 'px');
                tabs.eq(3).css('left', left4 + 'px');
            } else {
                tabs.eq(0).css('left', '');
                tabs.eq(1).css('left', '');
                tabs.eq(2).css('left', '');
                tabs.eq(3).css('left', '');
            }
        }, 0);
    }

    $(".SMLink").click(function (event) {
        event.preventDefault();
        $(".SMItem ").removeClass('current');
        $(this).closest(".SMItem").addClass("current");
    });

    function updateNav() {
        var main = $('.landingMainNav'),
            top = $('#topNav'),
            home = $('.backToHome');

        if (win.width() < 992) {
            if (home.length > 0) {
                home.addClass('mainNavItem mainSiteNav').detach().prependTo('#nav').wrap('<li></li>');
            }

            if (main.length > 0) {
                main.find('ul>li').detach().prependTo('#nav').find('>a').addClass('mainNavItem mainLandingItem');
            }

            if (top.length > 0) {
                top.find('ul>li').detach().appendTo('#nav').find('>a').addClass('mainNavItem topNavItem mainSiteNav');
            }
        }
    }

    function resetNav() {
        var home = $('#nav .backToHome'),
            top = $('#nav .topNavItem'),
            main = $('#nav .mainLandingItem');

        if (win.width() >= 992) {
            if (home.length > 0) {
                home.unwrap().removeClass('mainNavItem mainSiteNav').detach().prependTo('#topNavContainer');
            }

            if (main.length > 0) {
                main.removeClass('mainNavItem mainLandingItem mainSiteNav').closest('li').detach().prependTo('.landingMainNav ul');
            }

            if (top.length > 0) {
                top.removeClass('mainNavItem topNavItem').closest('li').detach().prependTo('#topNav ul');
            }
        }
    }
})(jQuery);